/*
 * Copyright (c) 2024. Dave van Rijn Development
 */

import './style/custom.scss';
import './js/util/startup';

import React from 'react';
import {createRoot} from 'react-dom/client';
import {createBrowserRouter, RouterProvider} from 'react-router';
import {Routes} from './js/routes';
import AppContextProvider from './js/components/context/appContext';
import ContentContextProvider from "./js/components/context/contentContext";

const router = createBrowserRouter(Routes);

const rootElement = document.getElementById('content');
if (rootElement) {
    createRoot(rootElement).render(
        <AppContextProvider>
            <ContentContextProvider>
                <RouterProvider router={router}/>
            </ContentContextProvider>
        </AppContextProvider>
    );
}